import {useEffect} from "react";
import {initChart} from "@design/pc/modules/chart";
import EmploymentChart from "@spa/features/search_job/pc/components/knowledge_panel/location_statistics/location_statistics_parts/EmploymentChart";
import EducationSalary from "@spa/features/search_job/pc/components/knowledge_panel/location_statistics/location_statistics_parts/EducationSalary";
import OccupationSalary from "@spa/features/search_job/pc/components/knowledge_panel/location_statistics/location_statistics_parts/OccupationSalary";
import IncomeDistributionGraph from "@spa/features/search_job/pc/components/knowledge_panel/location_statistics/location_statistics_parts/IncomeDistributionGraph";
import LocationStatisticsModal from "@spa/features/search_job/pc/components/knowledge_panel/location_statistics/location_statistics_parts/LocationStatisticsModal";

const LocationStatistics = ({
    locationStatistics,
    chartData
}) => {
    useEffect(() => {
        initChart(chartData);
    }, []);

    return (
        <>
            {/* 勤務地統計データ グラフあり */}
            <div className="p-knowledge u-dip_flex">
                <div className="p-knowledge_box--left">
                    <EmploymentChart locationStatistics={locationStatistics} />
                </div>

                <div className="p-knowledge_box--right">
                    <EducationSalary locationStatistics={locationStatistics} />
                    <div className="p-knowledge_content">
                        <div className="p-knowledge_list_wrap">
                            {locationStatistics.isDisplayableOccupationSalary && <p className="p-knowledge_title">Median Annual Earnings by Occupation</p>}
                            <div className="p-knowledge_list--flex">
                                <OccupationSalary locationStatistics={locationStatistics} />
                                <IncomeDistributionGraph locationStatistics={locationStatistics} />
                            </div>
                        </div>
                    </div>
                    <div className="p-help_btn_wrap u-mt10">
                        <button type="button" className="p-help_btn s-help--knowledge">About This Content</button>
                    </div>
                </div>
            </div>
            {/* /  勤務地統計データ グラフあり */}

            {/* ナレッジパネル勤務地統計データの説明モーダル */}
            <LocationStatisticsModal
                dataCommonsAccessedYear={locationStatistics.dataCommonsAccessedYear}
                dataCommonsAccessedDate={locationStatistics.dataCommonsAccessedDate}
            />
        </>
    );
}

export default LocationStatistics;
